import localAboutUsSample from "../Data/About(Content19).json";

export const LOCAL_ABOUT_US_SAMPLE = localAboutUsSample;

export const SAMPLE_ABOUT_US_JSON = JSON.stringify(localAboutUsSample, null, 2);

const isAboutUsShape = (value) =>
  Boolean(
    value?.title &&
      value?.subTitle &&
      Array.isArray(value?.cardData) &&
      value?.ourLeadership &&
      Array.isArray(value?.someDigipankians),
  );

export const getLocalAboutUsDisplay = () => ({
  ...localAboutUsSample,
  isLocalFallback: true,
});

export const normalizeAboutUsDisplay = (aboutUsResponse) => {
  const fallback = getLocalAboutUsDisplay();
  const apiData = aboutUsResponse?.data;

  if (!apiData || typeof apiData !== "object" || !isAboutUsShape(apiData)) {
    return fallback;
  }

  return {
    ...apiData,
    meta: {
      updatedAt: aboutUsResponse.updatedAt,
    },
    isLocalFallback: false,
  };
};

export const validateAboutUsJson = (parsed) => isAboutUsShape(parsed);
